<form #form="ngForm">
    <ng-container *ngIf="review">
        <ui-card>
            <app-segment-header title="performance.summary.reviewDetails.title"></app-segment-header>
            <div class="fields">
                <div class="field">
                    <label>{{ 'performance.summary.reviewDetails.titleLabel' | translate }}</label>
                    <div class="field-data">{{ review.title }}</div>
                </div>
                <div class="field">
                    <label>{{ 'performance.summary.reviewDetails.frequencyLabel' | translate }}</label>
                    <div class="field-data">{{ review.reoccuring }}</div>
                </div>
                <div class="field">
                    <label>{{ 'performance.summary.reviewDetails.reviewPeriod' | translate }}</label>
                    <div class="field-data">
                        {{ review.periodStart | appDate: 'mediumDate' }} -
                        {{ review.periodEnd | appDate: 'mediumDate' }}
                    </div>
                </div>
                <div class="field" *ngIf="review.instruction?.length">
                    <label>{{ 'performance.bulk-review.reviewInstructions' | translate }}</label>
                    <div class="field-data">{{ review.instruction }}</div>
                </div>
            </div>
        </ui-card>
        <ui-card>
            <app-segment-header title="performance.summary.reviewStartAndDueDate.title"></app-segment-header>
            <div class="fields flex">
                <div class="column-6 field margin-right-4">
                    <label class="font-medium">{{
                        'performance.summary.reviewStartAndDueDate.startDateLabel' | translate
                    }}</label>
                    <div>{{ review.scheduleAt | appDate: 'mediumDate' }}</div>
                </div>

                <div class="column-6 field">
                    <label class="font-medium">{{
                        'performance.summary.reviewStartAndDueDate.dueDateLabel' | translate
                    }}</label>
                    <div>{{ review.dueAt | appDate: 'mediumDate' }}</div>
                </div>
            </div>
        </ui-card>
        <ui-card>
            <app-segment-header title="performance.summary.revieweesAndParticipants.title"></app-segment-header>
            <div class="margin-bottom-2">
                <app-search
                    #searchBar
                    placeholder="components.dialog-common.searchDots"
                    (onSearch)="onSearch($event)"
                ></app-search>
            </div>
            <app-simple-table
                *ngIf="participants.length && rows?.length"
                [attr.data-cy]="'bulkReviewParticipantsTable'"
                [fixedHeight]="true"
                [columns]="columns"
                [rows]="rows"
            ></app-simple-table>
            <h3 *ngIf="!rows?.length" class="centered">{{ 'performance.participants.noResults' | translate }}</h3>
        </ui-card>
        <ui-card>
            <app-segment-header title="performance.summary.reviewTemplate.title"></app-segment-header>
            <div>
                <span class="review-template-name" *ngIf="review.templateId">{{
                    getTemplateName(review.templateId)
                }}</span>
            </div>
        </ui-card>
        <ui-card>
            <app-segment-header title="performance.summary.responseAccess.title"></app-segment-header>

            <div class="padding-bottom-2">
                <div class="padding-bottom-1">
                    <strong>{{ 'performance.summary.responseAccess.adminsLabel' | translate }}</strong>
                </div>
                <div>
                    <p>{{ 'performance.summary.responseAccess.adminsCanSeeResponsesNoMatterWhat' | translate }}</p>
                </div>
            </div>

            <div class="padding-bottom-2">
                <div class="padding-bottom-1">
                    <strong>{{ 'performance.summary.responseAccess.directManagersLabel' | translate }}</strong>
                    <ui-info
                        class="margin-left-1"
                        text="performance.bulk-review.responseAccess.directManagerSettingTooltip"
                    ></ui-info>
                </div>
                <div *ngIf="review.viewResultsBeforeCompletion; else canAlwaysSeeResponses">
                    <p>{{ 'performance.summary.responseAccess.directManagersCanAlwaysSeeResponses' | translate }}</p>
                </div>
                <ng-template #canAlwaysSeeResponses>
                    <p>
                        {{
                            'performance.summary.responseAccess.directManagersCanSeeResponsesOnceCompleted' | translate
                        }}
                    </p>
                </ng-template>
            </div>

            <div class="padding-bottom-2">
                <div class="padding-bottom-1">
                    <strong>{{
                        'performance.summary.responseAccess.revieweesAndOtherParticipants' | translate
                    }}</strong>
                </div>
                <div *ngIf="review.subjectCanViewResults">
                    <p>{{ 'performance.summary.responseAccess.resultVisibleToRevieweeSelf' | translate }}</p>
                </div>

                <div *ngIf="!review.subjectCanViewResults">
                    <p>{{ 'performance.summary.responseAccess.resultsInvisibleToRevieweeSelf' | translate }}</p>
                </div>

                <div *ngIf="review.participantsCanViewResults">
                    <p>{{ 'performance.summary.responseAccess.resultVisibleToOtherParticipants' | translate }}</p>
                </div>

                <div *ngIf="!review.participantsCanViewResults">
                    <p>{{ 'performance.summary.responseAccess.resultInvisibleToOtherParticipants' | translate }}</p>
                </div>
            </div>
        </ui-card>
    </ng-container>
</form>
